import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "category",
  label: "Category Listing",
  description: "Single category page: breadcrumb, header, product grid with filters.",
  supportedPages: ["category", "shop"],
  variants: [{ id: "v1", label: "V1 (Sidebar + Grid)" }],
  commonFields: [
    {
      key: "productCardVariant",
      label: "Card Style",
      type: "select",
      options: [{ label: "Standard (V1)", value: "v1" }],
      default: "v1",
    },
    { key: "itemsPerPage", label: "Items Per Page", type: "number", default: 12 },
    { key: "initialPriceRange.min", label: "Price Range Min", type: "number", default: 0 },
    { key: "initialPriceRange.max", label: "Price Range Max", type: "number", default: 50000 },
    { key: "showBreadcrumb", label: "Show Breadcrumb", type: "boolean", default: true },
    { key: "noProductsText", label: "No Products Text", type: "string", default: "No products found in this category." },
    { key: "filterDrawerTitle", label: "Filter Drawer Title", type: "string", default: "Filter Products" },
    { key: "applyFiltersLabel", label: "Apply Filters Label", type: "string", default: "Apply Filters" },
    ...SECTION_STYLE_FIELDS,
  ],
};
